module.exports = __webpack_public_path__ + "img/hero_3.393fb2e8.webp";